import api from "../config/api";
import { getErrorMessage } from "../config/errorHelper";

export const getInventory = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    if (filters.companyId)       params.append("companyId",       filters.companyId);
    if (filters.type)            params.append("type",            filters.type);
    if (filters.inventoryStatus) params.append("inventoryStatus", filters.inventoryStatus);
    if (filters.search)          params.append("search",          filters.search);
    return (await api.get(`/inventory?${params}`)).data;
  } catch (err) { throw new Error(getErrorMessage(err)); }
};

export const getInventoryItem = async (id) => {
  try { return (await api.get(`/inventory/${id}`)).data; }
  catch (err) { throw new Error(getErrorMessage(err)); }
};

export const updateInventoryItem = async (id, updates) => {
  try {
    const res = await api.put(`/inventory/${id}`, updates);
    if (res.data?.code === "ERROR") throw new Error(res.data.message);
    return res.data;
  } catch (err) {
    if (!(err.response || err.request)) throw err;
    throw new Error(getErrorMessage(err));
  }
};

// Export Excel (.xlsx) au lieu de CSV
export const exportInventoryXlsx = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.companyId)       params.append("companyId",       filters.companyId);
  if (filters.type)            params.append("type",            filters.type);
  if (filters.inventoryStatus) params.append("inventoryStatus", filters.inventoryStatus);
  if (filters.search)          params.append("search",          filters.search);

  const token = localStorage.getItem("token");
  const res   = await fetch(`/api/inventory/export/xlsx?${params}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  if (!res.ok) throw new Error("Erreur export Excel");

  const blob = await res.blob();
  const link = document.createElement("a");
  link.href  = URL.createObjectURL(blob);
  link.download = `inventaire-${new Date().toISOString().slice(0,10)}.xlsx`;
  link.click();
  URL.revokeObjectURL(link.href);
};

export const getWarrantyExpiringSoon = async () => {
  try { return (await api.get("/inventory/warranty")).data; }
  catch (err) { throw new Error(getErrorMessage(err)); }
};

export const getExpiredWarranties = async () => {
  try { return (await api.get("/inventory/warranty/expired")).data; }
  catch (err) { throw new Error(getErrorMessage(err)); }
};